import React from 'react';
import Reflux from 'reflux';
import {Button, Icon, message, Popconfirm} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, objectSerial, config} from 'Utils';
import {
    getTgSpecialOrderList,
    getGouXiaoUnitList,
    deleterRecord, getSpecialType
} from '../../service/specialOrder';
import moment from "moment";

class specialOrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['特殊订单'],
            showHideBtnIndex: '',
            key: 0,
            prolineVisible: false,
            selectedRowKeys: [],
            gouxiaoUnitList: [],
            rows: [],
            total: 1,
            searchObj: {
                status: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                salesUnitId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                oeOrderNumber: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            visible: false,
            value: '',
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        // console.log(name);
        if (name == 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from + ' 00:00:00',
                    endCreatedDate: value.end + ' 23:59:59'
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }

    };

    getSpecialTypeList() {
        getSpecialType().then(res => {
            if (res.code === 200) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                }
                this.setState({specialTypeList: arr});
            }
        })
    }

    /*筛选重置*/
    advanceReset() {
        this.setState({
            searchObj: {
                status: '',
                salesUnitId: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                startCreatedDate: '',
                endCreatedDate: '',
                s: 10,
                p: 1
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let obj = self.state.searchObj;
        getTgSpecialOrderList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })

    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        let self = this;
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        this.getSpecialTypeList();
        this.initData();
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [
                    {
                        text: '全部',
                        value: '0'
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    editRecord(record) {
        this.goView('specialOrder/edit/' + record.id);
    }

    deleteItem(record) {
        deleterRecord({id: record.id}).then(res => {
            if (res.code === 200) {
                openNotice('success', '删除成功');
                this.initData();
            }
        });
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {

    }

    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgSpecialOrderHeader/exportOrder?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            selectedRowKeys,
            showHideBtnIndex,
            visible,
            gouxiaoUnitList,
            loading,
            specialTypeList
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '登记日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate,
                        end: searchObj.endCreatedDate
                    }
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '0', text: '保存'},
                        {value: '1', text: '已提交'},
                        {value: '2', text: '已完成'},
                        {value: '3', text: '驳回'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.status
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    multiple: false,
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                },
                {
                    name: 'oeOrderNumber',
                    label: '订单号',
                    text: '输入订单号',
                    type: 'default',
                    defaultValue: searchObj.oeOrderNumber
                },
                {
                    name: 'settleOrder',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    type: 'default',
                    defaultValue: searchObj.settleOrder
                },
                {
                    name: 'contractOrderName',
                    label: '合同/订单',
                    text: '输入合同/订单',
                    type: 'default',
                    defaultValue: searchObj.contractOrderName
                },
                {
                    name: 'specialCode',
                    label: '价格单号',
                    text: '输入价格单号',
                    type: 'default',
                    defaultValue: searchObj.specialCode
                },
                {
                    name: 'specialType',
                    label: '订单类型',
                    text: '选择订单类型',
                    options: specialTypeList,
                    multiple: false,//支持多选
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.specialType
                }, {
                    name: 'remark',
                    label: '备注',
                    text: '输入备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '单号',
                    dataIndex: 'orderNumber',
                    render: (text, record, index) => {
                        return <a href={`#/specialOrder/${record.id}`}>{text}</a>
                    }
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName'
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    render: (text) => {
                        if (text === 0) {
                            return '保存'
                        }
                        if (text === 1) {
                            return '已提交'
                        }
                        if (text === 2) {
                            return '已完成'
                        }
                        if (text === 3) {
                            return '驳回'
                        }
                    }
                },
                {
                    title: '日期',
                    dataIndex: 'orderDate',
                    render: (text, record, index) => {
                        return <div>{moment(parseInt(text)).format('YYYY-MM-DD')}</div>
                    }
                },
                {
                    title: '订单号',
                    dataIndex: 'oeOrderNumber'
                },
                {
                    title: '合同/订单',
                    dataIndex: 'contractOrderName'
                },
                {
                    title: '结算对应号',
                    dataIndex: 'settleOrder'
                },
                {
                    title: '反馈',
                    dataIndex: 'feedback'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                // {
                //     title: '创建人',
                //     dataIndex: 'createdName'
                // },
                {
                    title: '操作',
                    render: (text, record, index) =>
                        <div>
                            {record.status === 0 || record.status == 3 ?
                                <div className="event">
                                    <Button style={{display: 'inline-block', marginRight: '10px'}} size={'small'}
                                            type="ghost"
                                            onClick={() => {
                                                this.editRecord(record)
                                            }}>编辑</Button>
                                    <Popconfirm placement="left" title='您确定要删除吗！' onConfirm={() => {
                                        this.deleteItem(record)
                                    }}>
                                        <Button size={'small'} type="danger">删除</Button>
                                    </Popconfirm>
                                </div> :
                                <span className="btn">暂无操作</span>}
                        </div>
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div>
                    <p style={{paddingLeft: '20px', color: 'red'}}><Icon type="exclamation-circle-o"/>【仪表】软件服务虚拟物料
                        审核员-林贤度</p>
                    <p style={{paddingLeft: '20px', color: 'red'}}><Icon type="exclamation-circle-o"/>【天毅行】软件服务虚拟物料
                        审核员-顾佳莹</p>
                </div>
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, left: 0}}
                            onClick={this.goView.bind(this, '/specialOrder/add')}>新增软件服务订单</Button>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>

        </div>
    }
}

export default withRouter(specialOrderList);



// WEBPACK FOOTER //
// ./src/routes/specialOrder/list.js